import { render, staticRenderFns } from "./MainSidebarArrow.vue?vue&type=template&id=2dacda20&scoped=true"
import script from "./MainSidebarArrow.vue?vue&type=script&lang=js"
export * from "./MainSidebarArrow.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarArrow.vue?vue&type=style&index=0&id=2dacda20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacda20",
  null
  
)

export default component.exports